import { render, staticRenderFns } from "./flash.vue?vue&type=template&id=0e490b81&scoped=true&lang=pug&"
import script from "./flash.vue?vue&type=script&lang=js&"
export * from "./flash.vue?vue&type=script&lang=js&"
import style0 from "./flash.vue?vue&type=style&index=0&id=0e490b81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e490b81",
  null
  
)

export default component.exports